import Vue from 'vue'

const commonComponents = require.context('./commons', true, /\.vue$/)
commonComponents.keys().forEach((fileName) => {
  const componentConfig = commonComponents(fileName)
  const componentName = componentConfig.default.name
  componentName &&
    Vue.component(componentName, componentConfig.default || componentConfig)
})

const layoutComponents = require.context('./layouts', true, /\.vue$/)
layoutComponents.keys().forEach((fileName) => {
  const componentConfig = layoutComponents(fileName)
  const componentName = componentConfig.default.name
  componentName &&
    Vue.component(componentName, componentConfig.default || componentConfig)
})

const requireThemes = require.context('@/styles/themes', true, /\.scss$/)
requireThemes.keys().forEach((fileName) => {
  require(`@/styles/themes/${fileName.slice(2)}`)
})
